import classNames from 'classnames/bind'

import useFreeInsuranceDetail from '$hooks/insurance/my/free/useFreeInsuranceDetail'

import Styles from './InsuranceGuaranteeList.module.scss'

const cx = classNames.bind(Styles)

export default function InsuranceGuaranteeList() {
    const {보장내용} = useFreeInsuranceDetail()
    return (
        <ul className={cx('article')}>
            {보장내용?.map(({보장, 보장금액}, index) => (
                <li key={index} className={cx('item')}>
                    <strong className={cx('item-title')}>{보장}</strong>
                    <b className={cx('value')}>{보장금액}원</b>
                </li>
            ))}
        </ul>
    )
}
